import { render, staticRenderFns } from "./TransferFunds.vue?vue&type=template&id=b6c75310&scoped=true"
import script from "./TransferFunds.vue?vue&type=script&lang=ts"
export * from "./TransferFunds.vue?vue&type=script&lang=ts"
import style0 from "./TransferFunds.vue?vue&type=style&index=0&id=b6c75310&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c75310",
  null
  
)

export default component.exports